import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import SearchIcon from '@material-ui/icons/Search';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MailIcon from '@material-ui/icons/Mail';
import NotificationsIcon from '@material-ui/icons/Notifications';

import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import {arrowDown, LogoIcon, LogoText, ShoppingCart} from '../../assets/images/images';
import './style.scss';
import {flags, userRoles} from "../../environment";
import {Select, Tooltip} from "@material-ui/core";
import {withRouter} from "react-router-dom";
import {getUserDataFromLocalStorage} from "../../services/utils";
import HttpService from "../../services/http.service";

const useStyles = makeStyles((theme) => ({

  menuButton: {
    marginRight: theme.spacing(2),
    padding: 5
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  search: {
    // position: 'relative',
    display: "flex",
    // borderRadius: theme.shape.borderRadius,
    // backgroundColor: theme.palette.common.white,
    '&:hover': {
      // backgroundColor: theme.palette.common.white,
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: `100% !important`,
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
    flexGrow: 1
  },
  sectionDesktop: {
    display: 'flex',
    alignItems: 'center',

    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}));

function PrimarySearchAppBar(props) {

  const [user, setUser] = useState(null)
  const [search, setSearch] = useState('null');
  const [category, setCategory] = useState('0');
  const [total, setTotal] = useState('0');
  let ip = localStorage.getItem("ip") ?? '';
  ip = ip && JSON.parse(ip)
  const [flag, setFlag] = useState(ip?.country_code || '');
  useEffect(() => {
    const user1 = getUserDataFromLocalStorage()
    if (user1) {
      HttpService.get(`api/addToCart/list?ssoId=${user1.ssoId}`).then(res => {
        if (res) {
          //console.log(res.data)
          setTotal(res?.data.length)
          //setLoading(false)
        }
      });
      setUser(user1)
    }
  }, []);
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{vertical: 'top', horizontal: 'right'}}
      id={menuId}
      keepMounted
      transformOrigin={{vertical: 'top', horizontal: 'right'}}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
      <MenuItem onClick={handleMenuClose}>My account</MenuItem>
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{vertical: 'top', horizontal: 'right'}}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{vertical: 'top', horizontal: 'right'}}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
        <IconButton aria-label="show 4 new mails" color="inherit">
          <Badge badgeContent={4} color="secondary">
            <MailIcon/>
          </Badge>
        </IconButton>
        <p>Messages</p>
      </MenuItem>
      <MenuItem>
        <IconButton aria-label="show 11 new notifications" color="inherit">
          <Badge badgeContent={11} color="secondary">
            <NotificationsIcon/>
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle/>
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );

  const accountHandler = () => {
    if (user) {
      props.history.push('/dashboard')
    } else {
      props.history.push('/signIn')
    }
  }
  const headerHandler = () => {
    props.history.push('/')
  }
  return (
    <div className={''}>
      <AppBar position="fixed">
        <Toolbar className='bg-green top-toolbar-container'>

          <button
            edge="start"
            className={[classes.menuButton, ' logo-container']}
            color="inherit"
            aria-label="open drawer"
            onClick={headerHandler}
          >
            <img src={LogoIcon} alt='AgriLive' className='logo-icon'/>
            <img src={LogoText} alt={''} className='logo-text'/>
          </button>
          <div className={classes.search}>
            <div className='navbar-search-container'>
              <Select
                className='dropdown bg-inactive'
                onChange={(event) => {
                  setCategory(event.target.value)
                }}
                defaultValue={"null"}
              >
                <MenuItem value="null"> <em>Select</em> </MenuItem>
                {userRoles.map((val, index) => (
                  <MenuItem value={val.value} key={`${val.value + index}`}>{val.text}</MenuItem>
                ))}
              </Select>
              <OutlinedInput
                className='flex-grow'
                style={{borderRadius: 0}}
                placeholder='Search products here'
                onChange={e => setSearch(e.target.value)}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => props.onClick(search, category)}
                      edge="end"
                    >
                      <SearchIcon className='heading-color'/>
                    </IconButton>
                  </InputAdornment>
                }
              />
            </div>
          </div>
          <div className={classes.sectionDesktop}>
            <Select
              className='country-section-dropdown '
              value={flag}
              onChange={(event) => {
                // console.log(event.target.value);
                setFlag(event.target.value)
              }}
              defaultValue={ip?.country_code}
            >
              <MenuItem value=""> <em>Please Select</em> </MenuItem>
              {flags.map((val, index) => (
                <MenuItem value={val.value} key={`${val.value + index}`}
                          className='menu-item1 display-flex align-items-center justify-content-center'>
                  <Tooltip  title={val.text}>
                    <img src={val.flag} alt={val.text} className='imk' width={25}/>
                  </Tooltip>
                  {/*{'pak'}*/}
                </MenuItem>))}
            </Select>

            <IconButton aria-label="show 4 new mails" color="inherit" onClick={accountHandler}>
              <div className='display-flex flex-column align-items-center'>
                {user ?
                  <span className=' mb-0 font-10 text-bold primary-family'> My Account</span>
                  :
                  <>
                    <span className=' mb-0 font-10 text-bold primary-family'> Hello, Sign In</span>
                    <span className=' mt--5 font-16 text-bold primary-family'> Account</span>
                  </>}

              </div>
              <img src={arrowDown} className='ml-10'/>
            </IconButton>
            <IconButton onClick={() => props.history.push('/summary')} aria-label="show 17 new notifications"
                        color="inherit" className='badge-container'>
              <Badge badgeContent={total} color="secondary">
                <ShoppingCart color='white'/>
              </Badge>
              {/*<span className=' font-16 ml-10'>*/}
              {/*  Cart*/}
              {/*</span>*/}
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </div>
  );
}

export default withRouter(PrimarySearchAppBar)

// 3115083101
// 03345257893
// 332.5268286
